import axios from "axios";
import { removeItemFromLocalStorage } from "~/lib/helperFuncation/localStorageService";
import { setIsUserLoginFalse } from "~/lib/store/slice/loginSlice";
import { myStore } from "~/lib/store/store";
import { AUTH_COOKIE_TOKEN, FCM_TOKEN, USER_COUNTRY_PHONE_CODE, USER_MOBILE_NUMBER } from "./constant";
import { deleteCookie, getCookie } from "./cookies";
import { environment } from "./envirement";

const api = axios.create({
  baseURL: environment.API_PATH,
});

api.interceptors.response.use(
  (response) => response,

  (error) => {
    if (error.code === "ERR_NETWORK") {
      console.log("Network error occurred");
    }

    if (error.code === "ERR_BAD_RESPONSE" && error.response?.data?.message === "Signature verification failed") {
      console.log("Signature verification failed");
    }

    return new Promise((_resolve, reject) => {
      if (error.response.status === 401 && error.config && !error.config.__isRetryRequest) {
        // Clear authentication data
        deleteCookie(AUTH_COOKIE_TOKEN);
        deleteCookie(FCM_TOKEN);

        removeItemFromLocalStorage(USER_COUNTRY_PHONE_CODE);
        removeItemFromLocalStorage(USER_MOBILE_NUMBER);

        // Dispatch logout action to update Redux state
        myStore.dispatch(setIsUserLoginFalse());
      }
      reject(error);
      // throw error;
    });
  },
);

api.interceptors.request.use(
  (config) => {
    const contentToken = getCookie(AUTH_COOKIE_TOKEN);
    config.headers = new axios.AxiosHeaders({
      "content-type": "application/json",
      Authorization: contentToken ? `Bearer ${contentToken}` : "",
    });
    return config;
  },
  (error) => Promise.reject(error),
);

export default api;
